export const suppressPostSignupPopups = (userId: string): void => {
  localStorage.setItem(`isNewToYouTabNew-${userId}`, 'false');
  localStorage.setItem(`candidateSortAnnouncement-${userId}`, 'false');
};
